import WeatherApp from './Componenets/WeatherApp/WeatherApp';

export default function App() {
  return (
    <div className="App">
      <WeatherApp></WeatherApp>
    </div>
  );
}
